export default __webpack_public_path__ + "static/media/enj.b3a405d4.svg";